import { useEffect } from 'react';
/* рассчитываем в винде куда именно мы кликнули, чтобы при клике на вертикальный скрол (если он есть),
не закрыть модалку, а пролистать ее с помощью мышки */
var getMousePosition = function getMousePosition(event) {
  var posx = 0;
  if (event.pageX) {
    posx = event.pageX;
  } else if (event.clientX) {
    posx = event.clientX;
  }
  return {
    x: posx
  };
};
export var useOnClickOutside = function useOnClickOutside(_ref) {
  var ref = _ref.ref,
    handler = _ref.handler,
    isOpen = _ref.isOpen,
    overlayRef = _ref.overlayRef;
  useEffect(function () {
    var listener = function listener(event) {
      var overlayScrollHeight = 0;
      var overlayClientHeight = 0;
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      if (isOpen && overlayRef && overlayRef.current) {
        overlayScrollHeight = overlayRef.current.scrollHeight;
        overlayClientHeight = overlayRef.current.clientHeight;
      }
      var xPosition = getMousePosition(event).x;
      // eslint-disable-next-line max-len
      if (overlayRef && overlayRef.current && !ref.current.contains(event.target) && xPosition < (overlayRef === null || overlayRef === void 0 ? void 0 : overlayRef.current.clientWidth) && overlayScrollHeight >= overlayClientHeight || overlayScrollHeight === overlayClientHeight) {
        handler(event);
      }
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, isOpen, overlayRef]);
};